<template>
  <div
    class="subheader py-2 py-lg-4"
    v-bind:class="subheaderClasses"
    id="kt_subheader"
  >
    <b-modal
      id="LockUserModal"
      title="ورود دوباره"
      @ok.prevent="login"
      @cancel.prevent="logout"
      ok-title="ورود"
      ok-variant="success"
      cancel-title="خروج"
      cancel-variant="danger"
      no-close-on-backdrop
      no-close-on-esc
      class="backdrop"
      hide-header-close
    >
      <p class="my-4 text-justify">
        مدتی است که شما از سیستم استفاده نکرده اید، رمز عبور خود را وارد کنید تا
        دوباره به سیستم وارد شوید
      </p>
      <b-alert variant="danger" :show="errors.length > 0">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-form-group label="رمز عبور:">
        <b-form-input
          type="password"
          v-model="form.password"
          placeholder="رمز عبور"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="کد تایید">
        <b-row>
          <b-col cols="5">
            <b-form-input
              v-model="form.captcha"
              placeholder="کد تایید"
            ></b-form-input>
          </b-col>
          <b-col cols="5">
            <b-img center fluid :src="captcha_img" style="height: 38px"></b-img>
          </b-col>
          <b-col>
            <b-button variant="warning" @click="resetCaptcha"
              ><b-icon icon="arrow-clockwise"></b-icon
            ></b-button>
          </b-col>
        </b-row>
      </b-form-group>
    </b-modal>
    <div
      class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="d-flex align-items-center flex-wrap mr-1">
        <h5 class="text-dark font-weight-bold my-2 mr-5">{{ title }}</h5>
        <ul
          class="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2"
        >
          <li class="breadcrumb-item">
            <router-link :to="'/dashboard'" class="subheader-breadcrumbs-home">
              <i class="flaticon2-shelter text-muted icon-1x"></i>
            </router-link>
          </li>

          <template v-for="(breadcrumb, i) in breadcrumbs">
            <li class="breadcrumb-item" :key="`${i}-${breadcrumb.id}`">
              <router-link
                v-if="breadcrumb.route"
                :key="i"
                :to="breadcrumb.route"
                class="text-muted"
                >{{ breadcrumb.title }}</router-link
              >
              <span class="text-muted" :key="i" v-if="!breadcrumb.route">{{
                breadcrumb.title
              }}</span>
            </li>
          </template>
        </ul>
      </div>
      <div class="d-flex align-items-center">
        <b-button :variant="timecss" size="sm" style="direction: ltr" disabled
          >{{ parseInt(OnlineTime / 60) }} : {{ OnlineTime % 60 }}</b-button
        >
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#LockUserModal___BV_modal_backdrop_ {
  opacity: 0.9;
}
.custom-v-dropdown {
  &.dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  &.dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import httpHelper from "../../../helpers/httpHelper";
import VueRecaptcha from "vue-recaptcha";
import sessionHelper from "../../../helpers/sessionHelper";

export default {
  name: "KTSubheader",
  components: {
    "vue-recaptcha": VueRecaptcha,
  },
  data() {
    return {
      OnlineTime: null,
      form: {
        email: sessionHelper.getUser().mobile,
        password: "",
        captcha: "",
        key:''
      },
      captcha_img:'',
      errors: [],
    };
  },
  props: {
    breadcrumbs: Array,
    title: String,
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },
    timecss() {
      if (this.OnlineTime >= 300) return "outline-success";
      else if (this.OnlineTime > 60 && this.OnlineTime < 300)
        return "outline-warning";
      else return "outline-danger";
    },
    subheaderClasses() {
      const classes = [];
      const style = this.layoutConfig("subheader.style");
      if (style) {
        classes.push(style);

        if (style === "solid") {
          classes.push("bg-white");
        }

        if (this.layoutConfig("subheader.fixed")) {
          classes.push("border-top");
        }
      }
      return classes.join(" ");
    },
  },
  methods: {
    resetCaptcha() {
      httpHelper.getData("cp").then((res) => {
        this.captcha_img = res.result.img;
        this.form.captcha = "";
        this.form.key = res.result.key;
      });
    },
    logout() {
      this.$router.push("/login");
    },
    login() {
      var data = {
        email: this.form.email,
        password: this.form.password,
        captcha: this.form.captcha,
        key:this.form.key
      };
      httpHelper
        .postData("users/login", data)
        .then((res) => {
          this.resetCaptcha();
          if (res.success == false) {
            this.errors = [res.error];
          } else {
            this.form.password = "";
            sessionHelper.setUser(res.result);
            this.errors = [];
            //this.$router.push({ name: "dashboard" });
            this.createTimeInterval();
            this.$bvModal.hide("LockUserModal");
          }
        })
        .finally(() => {});
    },
    onVerify(response) {
      if (response) {
        this.form.robot = true;
        this.form.captcha = response;
      }
    },
    createTimeInterval() {
      var self = this;
      var interval_id = setInterval(function () {
        self.OnlineTime = httpHelper.getOnlineTime() - 1;
        httpHelper.setOnlineTime(self.OnlineTime);
        if (self.OnlineTime <= 0) {
          localStorage.clear();
          self.$bvModal.show("LockUserModal");
          self.resetCaptcha();
          this.captcha_int = setInterval(function () {
            self.resetCaptcha();
          }, 60000);
          //self.$router.push("/login");
          clearInterval(interval_id);
        }
      }, 1000);
      // interval +1
      for (var i = 1; i < interval_id; i++) window.clearInterval(i);
      //for clearing all intervals
    },
  },
  mounted() {
    this.createTimeInterval();
    
  },
};
</script>
